export enum Icon {

  IC_DASHBOARD = 'ic--twotone-dashboard',
  IC_FILE_COPY = 'ic--twotone-file-copy',
  IC_LEADS = 'ic--twotone-supervised-user-circle',
  IC_DATE_RANGE = 'ic--twotone-date-range',
  IC_TWOTONE_BUSINESS_CENTER = 'ic--twotone-business-center',
  IC_ATTACH_FILE = 'ic--twotone-attach-file',
  IC_PERSON_PIN = 'ic--outline-perm-contact-calendar',
  RI_SURVEY_LINE = 'ri--survey-line',
  IC_ASSIGNMENT = 'ic--twotone-assignment',
  MDI_EMAIL = 'mdi--email',
  UIL_MEETING_BOARD = 'uil--meeting-board',
  FLU_PERSON = 'fluent--person-star-16-filled',
  STREAMLINE_HELP_CHAT_TWO_SOLID = 'streamline--help-chat-2-solid',
  IC_NOTIFICATIONS_ACTIVE = 'ic--twotone-notifications-active',
  IC_NOTIFICATIONS = 'ic--notifications',
  MDI_VIDEO_BOX = 'mdi--video-box',
  IC_CALENDAR_TODAY = 'ic--baseline-calendar-today',
  IC_ASSESSMENT = 'ic--twotone-assessment',
  IC_SETTINGS = 'ic--settings',
  IC_CUSTOM_DASHBOARD = 'ic--twotone-dashboard-customize',

  IC_ROUND_CLOSE = 'ic--round-close',
  IC_HELP = 'ic--twotone-help',
  IC_SAVE = 'ic--twotone-save',
  IC_ROUND_SAVE = 'ic--round-save',
  IC_VISIBILITY = 'ic--twotone-visibility',
  IC_VISIBILITY_OFF = 'ic--twotone-visibility-off',
  IC_MAIL = 'ic--twotone-mail',

  MDI_SEND = 'mdi--send',
  IC_SEARCH = 'ic--twotone-search',
  IC_MORE_HORIZ = 'ic--twotone-more-horiz',
  IC_FILTER_LIST = 'ic--twotone-filter-list',
  IC_REMOVE_RED_EYE = 'ic--remove-red-eye',

  SOLID_TRASH_ALT = 'fa-solid--trash-alt',
  IC_TWOTONE_CLOSE = 'ic--twotone-close',
  IC_EDIT = 'ic--twotone-edit',
  MDI_FILTER_PLUS = 'mdi--filter-plus-outline',
  MDI_FILTER_REMOVE = 'mdi--filter-remove-outline',
  MDI_INFO = 'mdi--information-circle',

  IC_CHECK_CIRCLE = 'ic--twotone-check-circle-outline',
  SOLID_EYE_SLASH = 'fa-solid--eye-slash',
  SOLID_FILE_EXCEL = 'fa-solid--file-excel',
  MDI_LINK_VARIANT = 'mdi--link-variant',
  MDI_DOWNLOAD = 'mdi--download',
  SOLID_USERS = 'fa-solid--users',
  SOLID_USER_PLUS = 'fa-solid--user-plus',

  IC_RADIO_BUTTON_CHECKED = 'ic--twotone-radio-button-checked',
  IC_RADIO_BUTTON_UNCHECKED = 'ic--twotone-radio-button-unchecked',
  IC_TWOTONE_KEYBOARD_ARROW_RIGHT = 'ic--twotone-keyboard-arrow-right',
  IC_TWOTONE_KEYBOARD_ARROW_DOWN = 'ic--twotone-keyboard-arrow-down',
  IC_KEYBOARD_ARROW_RIGHT = 'ic--keyboard-arrow-right',
  IC_KEYBOARD_ARROW_LEFT = 'ic--keyboard-arrow-left',

  IC_TWOTONE_OPEN_IN_NEW = 'ic--twotone-open-in-new',
  IC_OPEN_IN_NEW = 'ic--open-in-new',
  IC_TWOTONE_FULLSCREEN = 'ic--twotone-fullscreen',
  IC_TWOTONE_FULLSCREEN_EXIT = 'ic--twotone-fullscreen-exit',
  IC_ROUND_TABLE_CHART = 'ic--round-table-chart',

  IC_BASELINE_DRAG_INDICATOR = 'ic--baseline-drag-indicator',

  // Notificaiton Type Icons
  MATERIAL_SYMBOLS_ALARM_ADD_OUTLINE = 'material-symbols--alarm-add-outline',
  MATERIAL_SYMBOLS_INFO_OUTLINE = 'material-symbols--info-outline',
  MATERIAL_SYMBOLS_CHECK = 'material-symbols--check',
  MATERIAL_SYMBOLS_CANCEL = 'material-symbols--cancel',

  IC_FILTER_ALT = 'ic--twotone-filter-alt',
  IC_MENU = 'ic--twotone-menu',
  IC_BOOKMARKS = 'ic--twotone-bookmarks',
  MDI_RECENT = 'mdi--recent',

  MDI_INFORMATION_VARIANT = 'mdi--information-variant',
  IC_TWOTONE_SETTINGS = 'ic--twotone-settings',
  IC_TWOTONE_NOTIFICATIONS_OFF = 'ic--twotone-notifications-off',
  IC_TWOTONE_CLEAR_ALL = 'ic--twotone-clear-all',
  IC_TWOTONE_CHEVRON_RIGHT = 'ic--twotone-chevron-right',
  IC_BASELINE_KEYBOARD_ARROW_RIGHT = 'ic--baseline-keyboard-arrow-right',
  IC_TWOTONE_PERSON = 'ic--twotone-person',

  IC_TWOTONE_ACCOUNT_CIRCLE = 'ic--twotone-account-circle',
  IC_TWOTONE_ACCESS_TIME = 'ic--twotone-access-time',
  IC_TWOTONE_DO_NOT_DISTURB = 'ic--twotone-do-not-disturb',
  IC_TWOTONE_OFFLINE_BOLT = 'ic--twotone-offline-bolt',
  IC_TWOTONE_ARROW_DROP_DOWN = 'ic--twotone-arrow-drop-down',
  IC_TWOTONE_BUSINESS = 'ic--twotone-business',
  IC_TWOTONE_VERIFIED_USER = 'ic--twotone-verified-user',
  IC_TWOTONE_LOCK = 'ic--twotone-lock',

  // Quick Action Icons
  IC_TWOTONE_ADD = 'ic--twotone-add',
  IC_TWOTONE_DATE_RANGE = 'ic--twotone-date-range',
  IC_TWOTONE_PERSON_PIN = 'ic--twotone-person-pin',
  IC_TWOTONE_SUPERVISED_USER_CIRCLE = 'ic--twotone-supervised-user-circle',

  IC_TWOTONE_PICTURE_AS_PDF = 'ic--twotone-picture-as-pdf',
  MDI_FILE_PDF_OUTLINE = 'mdi--file-pdf-outline',
  MDI_BADGE_ACCOUNT_HORİZONTAL = 'mdi--badge-account-horizontal',
  MDI_PLUS_CIRCLE = 'mdi--plus-circle',
  IC_TWOTONE_WARNING = 'ic--twotone-warning',
  IC_TWOTONE_CANCEL = 'ic--twotone-cancel',
  IC_TWOTONE_MINUS = 'ic--twotone-minus',

  MDI_ALERT_CIRCLE = 'mdi--alert-circle',
  IC_KEYBOARD_ARROW_UP = 'ic--keyboard-arrow-up',
  IC_KEYBOARD_ARROW_DOWN = 'ic--keyboard-arrow-down',

  MDI_SUBDIRECTORY_ARROW_RIGHT = 'mdi--subdirectory-arrow-right',

  IC_TWOTONE_LINK = 'ic--twotone-link',
  IC_TWOTONE_CLEAR = 'ic--twotone-clear',
  SOLID_LIST_ALT = 'fa-solid--list-alt',
  MATERIAL_SYMBOLS_CIRCLE = 'material-symbols--circle',

  MDI_KEYBOARD = 'mdi--keyboard',
  IC_BASELINE_VERIFIED = 'ic--baseline-verified',
  IC_INFO_OUTLINE = 'ic--info-outline',
  AKAR_ICONS_COPY = 'akar-icons--copy',
  OOUI_SUMMARY_LTR = 'ooui--text-summary-ltr',
  IC_TWOTONE_DELETE = 'ic--twotone-delete',
  IC_QUERY_BUILDER = 'ic--query-builder',

  IC_ROUND_BRIGHTNESS_4 = 'ic--round-brightness-4',
  IC_ROUND_BRIGHTNESS_5 = 'ic--round-brightness-5',
  IC_ROUND_BRIGHTNESS_6 = 'ic--round-brightness-6',

  IC_TWOTONE_TODAY = 'ic--twotone-today',
  FA_SOLID_BRIEFCASE = 'fa-solid--briefcase',
  FA_SOLID_USER_CIRCLE = 'fa-solid--user-circle',
  IC_HISTORY = 'ic--history',
  TOKEN_BRANDED_CHAT = 'token-branded--chat',
  FA_SOLID_FOLDER_OPEN = 'fa-solid--folder-open',
  IC_HELP_OUTLINE = 'ic--help-outline',
  FA_SOLID_DOWNLOAD = 'fa-solid--download',
  FA_SOLID_FILE_UPLOAD = 'fa-solid--file-upload',
  FA_SOLID_UPLOAD = 'fa-solid--upload',
  FA_SOLID_FILE_SIGNATURE = 'fa-solid--file-signature',
  IC_CHECK = 'ic--check',
  IC_CANCEL = 'ic--cancel',
  FLUENT_CALENDAR_CANCEL_16_FILLED = 'fluent--calendar-cancel-16-filled',
  IC_TWOTONE_IMAGE = 'ic--twotone-image',
  IC_TWONE_TEXT_SNIPPET = 'ic--twotone-text-snippet',

  IC_TWOTONE_BAR_CHART = 'ic--twotone-bar-chart',
  IC_ROUND_NOTIFICATION_IMPORTANT = 'ic--round-notification-important',
  IC_TWOTONE_HOME = 'ic--twotone-home',

  IC_TWOTONE_LAYERS_CLEAR = 'ic--twotone-layers-clear',
  IC_OUTLINE_LINK_OFF = 'ic--outline-link-off',

  TABLER_MAIL = 'tabler--mail',
  LOGOS_WHATSAPP_ICON = 'logos--whatsapp-icon',
  SKILL_ICONS_INSTAGRAM = 'skill-icons--instagram',
  LOGOS_FACEBOOK = 'logos--facebook',
  PEPICONS_PENCIL_TICKET_CIRCLE_FILLED = 'pepicons-pencil--ticket-circle-filled',
  MDI_TICKET_CONFIRMATION_OUTLINE = 'mdi--ticket-confirmation-outline',

  IC_BASELINE_CHECK_CIRCLE = 'ic--baseline-check-circle',
  IC_BASELINE_CANCEL = 'ic--baseline-cancel',

  IC_BASELINE_ADD_CIRCLE = 'ic--baseline-add-circle',
  IC_BASELINE_SETTINGS_BACKUP_RESTORE = 'ic--baseline-settings-backup-restore',
  IC_EVENT = 'ic--event',
  IC_MAIL_OUTLINE = 'ic--mail-outline',
  IC_ROOM = 'ic--room',
  IC_BASELINE_BAR_CHART = 'ic--baseline-bar-chart',
  IC_ROUND_ACCOUNT_CIRCLE = 'ic--round-account-circle',
  IC_TWOTONE_CALENDAR_TODAY = 'ic--twotone-calendar-today',
  IC_ROUND_INFO = 'ic--round-info',
  IC_BASELINE_PEOPLE = 'ic--baseline-people',

  MDI_SQUARE_EDIT_OUTLINE = 'mdi--square-edit-outline',
  FA_SOLID_FILE_CONTRACT = 'fa-solid--file-contract',
  IC_TWOTONE_SEND = 'ic--twotone-send',
  IC_TWOTONE_DESCRIPTION = 'ic--twotone-description',
  MDI_FILE_EDIT = 'mdi--file-edit',
  MDI_FILE_CANCEL = 'mdi--file-cancel',
  MDI_FILE_CHECK = 'mdi--file-check',
  IC_BASELINE_OFFLINE_BOLT = 'ic--baseline-offline-bolt',
  IC_LOCAL_OFFER = 'ic--local-offer',
  MDI_PERSON_ARROW_LEFT = 'mdi--person-arrow-left',
  IC_BASELINE_ARROW_DROP_DOWN_CIRCLE = 'ic--baseline-arrow-drop-down-circle',
  IC_COMMENT = 'ic--comment',
  IC_TWOTONE_DONE = 'ic--twotone-done',

  IC_REFRESH = 'ic--refresh',
  IC_BASELINE_ASSIGNMENT = 'ic--baseline-assignment',
  IC_CLOSE = 'ic--close',
  FA_SOLID_FILE_ALT = 'fa-solid--file-alt',
  FA_SOLID_PEN_FANCY = 'fa-solid--pen-fancy',
  FA_SOLID_NEWSPAPER = 'fa-solid--newspaper',
  FA_SOLID_SIGNATURE = 'fa-solid--signature',
  FA_SOLID_HOURGLASS_START = 'fa-solid--hourglass-start',

  IC_OUTLINE_CHECK = 'ic--outline-check',
  IC_OUTLINE_WATCH_LATER = 'ic--outline-watch-later',
  FA_SOLID_CLIPBOARD_LIST = 'fa-solid--clipboard-list',
  RI_FILE_4_FILL = 'ri--file-4-fill',
  MATERIAL_SYMBOLS_FILE_COPY_ROUNDED = 'material-symbols--file-copy-rounded',
  MDI_FILE_DOCUMENT_BOX = 'mdi--file-document-box',
  IC_ROUND_INSERT_DRIVE_FILE = 'ic--round-insert-drive-file',
  IC_TWOTONE_INSERT_DRIVE_FILE = 'ic--twotone-insert-drive-file',
  PH_FILE_TEXT_FILL = 'ph--file-text-fill',

  IC_OUTLINE_FOLDER = 'ic--outline-folder',
  IC_OUTLINE_FILTER = 'ic--outline-filter',
  MDI_ARRANGE_SEND_BACKWARD = 'mdi--arrange-send-backward',
  ICONAMOON_QUESTION_MARK_SQUARE = 'iconamoon--question-mark-square',
  LUCIDE_SETTINGS_2 = 'lucide--settings-2',

  IC_WARNING = 'ic--twotone-warning',
  IC_DOCUMENT = 'ic--document',
  IC_UPLOAD = 'ic--upload',
  IC_ADD = 'ic--add',
  IC_DELETE = 'ic--delete',
  IC_TWOTONE_ERROR = 'ic--twotone-error',

  IC_TWOTONE_SAVE_ALT = 'ic--twotone-save-alt',
  IC_TWOTONE_360 = 'ic--twotone-360',
  IC_TWOTONE_UPDATE = 'ic--twotone-update',
  MDI_FOLDER_PLUS_OUTLINE = 'mdi--folder-plus-outline',
  IC_MORE_VERT = 'ic--more-vert',

  IC_LAUNCH = 'ic--launch',
  IC_BASELINE_CHECK_BOX = 'ic--baseline-check-box',
  IC_ROUND_DELETE_FOREVER = 'ic--round-delete-forever',

  IC_LIST = 'ic--list',
  IC_VIEW_MODULE = 'ic--view-module',
  IC_STAR = 'ic--star',
  IC_STAR_BORDER = 'ic--star-border',
  IC_TWOTONE_STAR = 'ic--twotone-star',
  IC_TWOTONE_STAR_BORDER = 'ic--twotone-star-border',
  MATERIAL_SYMBOLS_KID_STAR = ' material-symbols--kid-star',
  MATERIAL_SYMBOLS_KID_STAR_OUTLINE = 'material-symbols--kid-star-outline',

  IC_TWOTONE_ARROW_RIGHT = 'ic--twotone-arrow-right',
  IC_BASELINE_FILE_COPY = 'ic--baseline-file-copy',
  IC_CONTENT_COPY = 'ic--content-copy',

  IC_TWOTONE_LOCAL_AIRPORT = 'ic--twotone-local-airport',
  IC_TWOTONE_LOCAL_SHIPPING = 'ic--twotone-local-shipping',
  IC_TWOTONE_DIRECTIONS_BOAT = 'ic--twotone-directions-boat',

  MDI_USERS_GROUP = 'mdi--users-group',
  IC_OUTLINE_ERROR = 'ic--outline-error',
  IC_BASELINE_ATTACH_MONEY = 'ic--baseline-attach-money',
  IC_BASELINE_DONE_ALL = 'ic--baseline-done-all',
  IC_BASELINE_INFO = 'ic--baseline-info',
  IC_BUSINESS_CENTER = 'ic--business-center',
  IC_OUTLINE_ACCOUNT_BALANCE = 'ic--outline-account-balance',
  IC_ROUND_PERM_CONTACT_CALENDAR = 'ic--round-perm-contact-calendar',
  MDI_BELL_RING = 'mdi--bell-ring',
  IC_TWOTONE_LOCATION_ON = 'ic--twotone-location-on',
  MDI_ARROW_DOWN_BOLD = 'mdi--arrow-down-bold',
  MDI_ARROW_UP_BOLD = 'mdi--arrow-up-bold',

  IC_BASELINE_ADD_CHART = 'ic--baseline-add-chart',
  GUIDANCE_SEND = 'guidance--send',
  FLUENT_SHIELD_TASK = 'fluent--shield-task-24-regular',
  FLUENT_MAIL_UNREAD = 'fluent--mail-unread-48-regular',
  ICONAMOOON_TICKET = 'iconamoon--ticket-thin',
  FLUENT_MAIL_READ = 'fluent--mail-read-48-regular',
  FA_SOLID_CHART_PIE = 'fa-solid--chart-pie',
  MDI_CHART_ARC = 'mdi--chart-arc',

  MDI_ARROW_RIGHT = 'mdi--arrow-right',
  MDI_FORMAT_ALIGN_JUSTIFY = 'mdi--format-align-justify',
  IC_ARROW_BACK = 'ic--arrow-back',
  IC_BASELINE_PERSON_OUTLINE = 'ic--baseline-person-outline',
  MDI_CHEVRON_DOWN = 'mdi--chevron-down',
  IC_BASELINE_CALL_SPLIT = 'ic--baseline-call-split',
  MDI_CHECK = 'mdi--check',
  MDI_CHECK_ALL = 'mdi--check-all',
  MATERIAL_SYMBOLS_ASSIGNMENT_ADD_OUTLINE = 'material-symbols--assignment-add-outline',
  OOUI_SPEECH_BUBBLE_ADD_RTL = 'ooui--speech-bubble-add-rtl',
  MDI_CLOCK_TIME_THREE_OUTLINE = 'mdi--clock-time-three-outline',
  IC_BASELINE_SMS = 'ic--baseline-sms',
  IC_OUTLINE_ARROW_DROP_DOWN = 'ic--outline-arrow-drop-down',
  IC_TWOTONE_ARROW_DROP_UP = 'ic--twotone-arrow-drop-up',
  MINGCUTE_DOWNLOAD_FILL = 'mingcute--download-fill',
  IC_LINK = 'ic--link',
  MDI_TEXT_LONG = 'mdi--text-long',
  MATERIAL_SYMBOLS_SHORT_TEXT = 'material-symbols--short-text',
  ENTYPO_CYCLE = 'entypo--cycle',
  MDI_CLEAR_CIRCLE_OUTLINE = 'mdi--clear-circle-outline',
  PH_CHECK_CIRCLE_DUOTONE = 'ph--check-circle-duotone',
  MDI_PLUS_CIRCLE_OUTLINE = 'mdi--plus-circle-outline',
  FLUENT_MAIL_20_FILLED = 'fluent--mail-20-filled',
  CARBON_LOCATION_COMPANY = 'carbon--location-company',
  UIS_CALENDER = 'uis--calender',
  MINGCUTE_TICKET_FILL = 'mingcute--ticket-fill',
  IC_BASELINE_CALL_MERGE = 'ic--baseline-call-merge',
  MATERIAL_SYMBOLS_LIGHT_UNDO = 'material-symbols-light--undo',
  MATERIAL_SYMBOLS_LIGHT_REDO_ROUNDED = 'material-symbols-light--redo-rounded',
  MATERIAL_SYMBOLS_LIGHT_CHECK = 'material-symbols-light--check',
  IC_BASELINE_SETTINGS = 'ic--baseline-settings',
  IC_BASELINE_ASSISTANT = 'ic--baseline-assistant',
  IC_BASELINE_CATEGORY = 'ic--baseline-category',
  IC_BASELINE_DATE_RANGE = 'ic--baseline-date-range',
  IC_BASELINE_MANAGE_HISTORY = 'ic--baseline-manage-history',
  MDI_CHEVRON_UP = 'mdi--chevron-up',
  MDI_DOTS_HORIZONTAL = 'mdi--dots-horizontal',
  MDI_ADD = 'mdi--add',
  MATERIAL_SYMBOLS_ADD_CIRCLE_OUTLINE = 'material-symbols--add-circle-outline',
  MDI_TIMER_SAND_EMPTY = 'mdi--timer-sand-empty',
  MDI_FACTORY = 'mdi--factory',
  MDI_PLAY_CIRCLE_OUTLINE = 'mdi--play-circle-outline',
  MDI_VIDEO_ACCOUNT = 'mdi--video-account',
  MDI_CLOCK_TIME_FOUR_OUTLINE = 'mdi--clock-time-four-outline',
  MDI_DELETE_CIRCLE_OUTLINE = 'mdi--delete-circle-outline',
  AKAR_ICONS_ARROW_UP_DOWN = 'akar-icons--arrow-up-down',
  MDI_CLOCK_OUTLINE = 'mdi--clock-outline',
  MDI_CLOSE_CIRCLE_OUTLINE = 'mdi--close-circle-outline',
  MDI_RECORD_REC = 'mdi--record-rec',
  MDI_RECORD_CIRCLE = 'mdi--record-circle',
  IC_TWOTONE_KEYBOARD_ARROW_LEFT = 'ic--twotone-keyboard-arrow-left',
  MDI_OPEN_IN_NEW = 'mdi--open-in-new',
  IC_VIEW_DAY = 'ic--view-day',

  // Mail Icons
  IC_TWOTONE_MORE_VERT = 'ic--twotone-more-vert',
  IC_TWOTONE_REPLY_ALL = 'ic--twotone-reply-all',
  IC_TWOTONE_FORWARD = 'ic--twotone-forward',
  IC_TWOTONE_REPLY = 'ic--twotone-reply',
  IC_TWOTONE_ARROW_BACK = 'ic--twotone-arrow-back',
  IC_TWOTONE_FOLDER = 'ic--twotone-folder',
  IC_TWOTONE_INBOX = 'ic--twotone-inbox',
  IC_TWOTONE_FLAG_CIRCLE = 'ic--twotone-flag-circle',
  IC_TWOTONE_MARK_EMAIL_UNREAD = 'ic--twotone-mark-email-unread',
  IC_TWOTONE_SNIPPET_FOLDER = 'ic--twotone-snippet-folder',
  IC_TWOTONE_LABEL_IMPORTANT = 'ic--twotone-label-important',
  MDI_EAR_HEARING = 'mdi--ear-hearing',
  MDI_MINUS = 'mdi--minus',
  AKAR_ICONS_ARROW_RIGHT = 'akar-icons--arrow-right',
  FA_SOLID_EDIT = 'fa-solid--edit',
  IC_TWOTONE_CHECK = 'ic--twotone-check',
  MDI_LOGOUT = 'mdi--logout',

  IC_OPEN = 'ic--outline-open-in-new',
  IC_REMOVE_CIRCLE = 'ic--twotone-remove-circle-outline',
  IC_DRAG_INDICATOR = 'ic--twotone-drag-indicator',
  IC_INFO = 'ic--twotone-info',
  IC_USER_SETTINGS_FILL = 'ri--user-settings-fill',

  MDI_IMAGE = 'mdi--image',
  MDI_ALERT_OUTLINE = 'mdi--alert-outline',
  MDI_ALERT = 'mdi--alert',
  MDI_VIEW_MODULE = 'mdi--view-module',
  MDI_VIDEO = 'mdi--video',
  MDI_CALENDAR_CHECK = 'mdi--calendar-check',

  IC_BASELINE_STAR = 'ic--baseline-star',
  IC_BASELINE_CLOSE = 'ic--baseline-close',
  IC_REMOVE_CIRCLE_OUTLINE = 'ic--remove-circle-outline',

  IC_ACCESS_TIME = 'ic--access-time',
  IC_BASELINE_MILITARY_TECH = 'ic--baseline-military-tech',
  IC_BASELINE_MAIL = 'ic--baseline-mail',
  IC_BASELINE_CLEAR_ALL = 'ic--baseline-clear-all',
  FA_SOLID_TAGS = 'fa-solid--tags',
  FA_SOLID_ROAD = 'fa-solid--road',
  CLARITY_FLOW_CHART_LINE = 'clarity--flow-chart-line',
  MINGCUTE_COPY_LINE = 'mingcute--copy-line',

  MDI_GRAPH = 'mdi--graph',
  MDI_TAG = 'mdi--tag',
  ICON_PARK_OUTLINE_COPY_LINK = 'icon-park-outline--copy-link',
  MDI_FILE_TREE_OUTLINE = 'mdi--file-tree-outline',
  MDI_FAMILY_TREE = 'mdi--family-tree',
  IC_BASELINE_CHECK = 'ic--baseline-check',
  MDI_ARROW_EXPAND = 'mdi--arrow-expand',
  IC_OUTLINE_VERIFIED = 'ic--outline-verified',
  IC_BASELINE_REPLAY = 'ic--baseline-replay',
  MDI_CHAT_OUTLINE = 'mdi--chat-outline',
  IC_BASELINE_FULLSCREEN = 'ic--baseline-fullscreen',
  IC_FULLSCREEN_EXIT = 'ic--fullscreen-exit',
  MDI_SCHEDULE = 'mdi--schedule',
  MDI_ACCOUNT_MULTIPLE = 'mdi--account-multiple',
  IC_BASELINE_TABLE_CHART = 'ic--baseline-table-chart',
  IC_BASELINE_PIE_CHART = 'ic--baseline-pie-chart',
  IC_BASELINE_NOT_INTERESTED = 'ic--baseline-not-interested',
  IC_BASELINE_FILE_DOWNLOAD = 'ic--baseline-file-download',
  IC_BASELINE_FILE_UPLOAD = 'ic--baseline-file-upload',
  IC_BASELINE_DONE = 'ic--baseline-done',
  IC_TWOTONE_FILTER_ALT = 'ic--twotone-filter-alt',
  MATERIAL_SYMBOLS_CONVERSION_PATH = 'material-symbols--conversion-path',
  MATERIAL_SYMBOLS_CONVERSION_PATH_OFF = 'material-symbols--conversion-path-off',
  MDI_MINUS_CIRCLE = 'mdi--minus-circle',
  IC_BASELINE_FORMAT_LIST_BULLETED = 'ic--baseline-format-list-bulleted',
  IC_TWOTONE_INSERT_COMMENT = 'ic--twotone-insert-comment',
  IC_TWOTONE_NOTIFICATIONS = 'ic--twotone-notifications',
  IC_BASELINE_NOTIFICATION_ACTIVE = 'ic--baseline-notifications-active',

  IC_OUTLINE_NOTIFICATIONS_ACTIVE = 'ic--outline-notifications-active',
  IC_ROUND_SETTINGS = 'ic--round-settings',
  IC_OUTLINE_ASSESSMENT = 'ic--outline-assessment',
  IC_OUTLINE_ASSIGNMENT = 'ic--outline-assignment',
  IC_OUTLINE_ATTACH_FILE = 'ic--outline-attach-file',
  IC_OUTLINE_BUSINESS_CENTER = 'ic--outline-business-center',
  IC_OUTLINE_DASHBOARD = 'ic--outline-dashboard',
  IC_OUTLINE_DASHBOARD_CUSTOMIZE = 'ic--outline-dashboard-customize',
  IC_OUTLINE_DATE_RANGE = 'ic--outline-date-range',
  IC_OUTLINE_FILE_COPY = 'ic--outline-file-copy',
  IC_OUTLINE_PERM_CONTACT_CALENDAR = 'ic--outline-perm-contact-calendar',
  IC_OUTLINE_SUPERVISED_USER_CIRCLE = 'ic--outline-supervised-user-circle',
  MDI_CLOCK_ALERT_OUTLINE = 'mdi--clock-alert-outline',
  IC_BASELINE_QUESTION_MARK = 'ic--baseline-question-mark',
  IC_ROUND_STAR_RATE = 'ic--round-star-rate',
  MDI_CALENDAR_ALERT = 'mdi--calendar-alert',
  MDI_EXCLAMATION_THICK = 'mdi--exclamation-thick',
  MDI_BULLSEYE_ARROW = 'mdi--bullseye-arrow',
  MDI_FILE_DOCUMENT_OUTLINE = 'mdi--file-document-outline',
  MDI_TIMER_SAND = 'mdi--timer-sand',
  IC_OUTLINE_DRAG_INDICATOR = 'ic--outline-drag-indicator',
  PEPICONS_PENCIL_DOWN_UP = 'pepicons-pencil--down-up',

  IC_BASELINE_STAR_RATE = 'ic--baseline-star-rate',
  IC_SHARP_LOCATION_ON = 'ic--sharp-location-on',
  IC_OUTLINE_SORT = 'ic--outline-sort',
  MDI_CAMERA = 'mdi--camera',
  MDI_CELLPHONE = 'mdi--cellphone',
  MDI_LINKEDIN = 'mdi--linkedin',
  MDI_MAP_MARKER = 'mdi--map-marker',
  IC_TWOTONE_PHONE_IN_TALK = 'ic--twotone-phone-in-talk',
  MDI_CALENDAR_STAR = 'mdi--calendar-star',
  MDI_LOGIN_VARIANT = 'mdi--login-variant',

  SYSTEM_UICONS_HIERARCHY = 'system-uicons--hierarchy',
  HUGEICONS_NODE_ADD = 'hugeicons--node-add',

  IC_BASELINE_AUTO_FIX_HIGH = 'ic--baseline-auto-fix-high',
  IC_BASELINE_DOCUMENT_SCANNER = 'ic--baseline-document-scanner',
  FLUENT_CHAT_HELP_24_FILLED = 'fluent--chat-help-24-filled',
  IC_BASELINE_INSERT_CHART = 'ic--baseline-insert-chart',
  TDESIGN_REFRESH = 'tdesign--refresh',
  MDI_TABLE = 'mdi--table',
  MATERIAL_SYMBOLS_SPEAKER_NOTES = 'material-symbols--speaker-notes',
  MDI_MESSAGE_QUESTION = 'mdi--message-question',
  MDI_SYNC_CIRCLE = 'mdi--sync-circle',
  MDI_TICK_CIRCLE = 'mdi--tick-circle',
  MATERIAL_SYMBOLS_ROTATE_LEFT = 'material-symbols--rotate-left',
  MDI_WARNING_CIRCLE_OUTLINE = 'mdi--warning-circle-outline',
  FLUENT_ARROW_SYNC_CIRCLE_28_FILLED = 'fluent--arrow-sync-circle-28-filled'

}

export enum IconSVG {
  WHATSAPP = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 256 258" style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);"><defs><linearGradient id="IconifyId-1930a993d58-b4f590-0" x1="50%" x2="50%" y1="100%" y2="0%"><stop offset="0%" stop-color="#1FAF38"></stop><stop offset="100%" stop-color="#60D669"></stop></linearGradient><linearGradient id="IconifyId-1930a993d58-b4f590-1" x1="50%" x2="50%" y1="100%" y2="0%"><stop offset="0%" stop-color="#F9F9F9"></stop><stop offset="100%" stop-color="#FFF"></stop></linearGradient></defs><path fill="url(#IconifyId-1930a993d58-b4f590-0)" d="M5.463 127.456c-.006 21.677 5.658 42.843 16.428 61.499L4.433 252.697l65.232-17.104a122.994 122.994 0 0 0 58.8 14.97h.054c67.815 0 123.018-55.183 123.047-123.01c.013-32.867-12.775-63.773-36.009-87.025c-23.23-23.25-54.125-36.061-87.043-36.076c-67.823 0-123.022 55.18-123.05 123.004"></path><path fill="url(#IconifyId-1930a993d58-b4f590-1)" d="M1.07 127.416c-.007 22.457 5.86 44.38 17.014 63.704L0 257.147l67.571-17.717c18.618 10.151 39.58 15.503 60.91 15.511h.055c70.248 0 127.434-57.168 127.464-127.423c.012-34.048-13.236-66.065-37.3-90.15C194.633 13.286 162.633.014 128.536 0C58.276 0 1.099 57.16 1.071 127.416Zm40.24 60.376l-2.523-4.005c-10.606-16.864-16.204-36.352-16.196-56.363C22.614 69.029 70.138 21.52 128.576 21.52c28.3.012 54.896 11.044 74.9 31.06c20.003 20.018 31.01 46.628 31.003 74.93c-.026 58.395-47.551 105.91-105.943 105.91h-.042c-19.013-.01-37.66-5.116-53.922-14.765l-3.87-2.295l-40.098 10.513l10.706-39.082Z"></path><path fill="#FFF" d="M96.678 74.148c-2.386-5.303-4.897-5.41-7.166-5.503c-1.858-.08-3.982-.074-6.104-.074c-2.124 0-5.575.799-8.492 3.984c-2.92 3.188-11.148 10.892-11.148 26.561c0 15.67 11.413 30.813 13.004 32.94c1.593 2.123 22.033 35.307 54.405 48.073c26.904 10.609 32.379 8.499 38.218 7.967c5.84-.53 18.844-7.702 21.497-15.139c2.655-7.436 2.655-13.81 1.859-15.142c-.796-1.327-2.92-2.124-6.105-3.716c-3.186-1.593-18.844-9.298-21.763-10.361c-2.92-1.062-5.043-1.592-7.167 1.597c-2.124 3.184-8.223 10.356-10.082 12.48c-1.857 2.129-3.716 2.394-6.9.801c-3.187-1.598-13.444-4.957-25.613-15.806c-9.468-8.442-15.86-18.867-17.718-22.056c-1.858-3.184-.199-4.91 1.398-6.497c1.431-1.427 3.186-3.719 4.78-5.578c1.588-1.86 2.118-3.187 3.18-5.311c1.063-2.126.531-3.986-.264-5.579c-.798-1.593-6.987-17.343-9.819-23.64"></path></svg>`,
  FACEBOOK = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 256 256" style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);"><path fill="#1877F2" d="M256 128C256 57.308 198.692 0 128 0C57.308 0 0 57.307 0 128c0 63.888 46.808 116.843 108 126.445V165H75.5v-37H108V99.8c0-32.08 19.11-49.8 48.347-49.8C170.352 50 185 52.5 185 52.5V84h-16.14C152.958 84 148 93.867 148 103.99V128h35.5l-5.675 37H148v89.445c61.192-9.602 108-62.556 108-126.445"></path><path fill="#FFF" d="m177.825 165l5.675-37H148v-24.01C148 93.866 152.959 84 168.86 84H185V52.5S170.352 50 156.347 50C127.11 50 108 67.72 108 99.8V128H75.5v37H108v89.445A128.959 128.959 0 0 0 128 256a128.9 128.9 0 0 0 20-1.555V165h29.825"></path></svg>`,
  INSTAGRAM = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 256 256" style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);"><g fill="none"><rect width="256" height="256" fill="url(#IconifyId-1930aa7e158-d136c0-8)" rx="60"></rect><rect width="256" height="256" fill="url(#IconifyId-1930aa7e158-d136c0-9)" rx="60"></rect><path fill="#fff" d="M128.009 28c-27.158 0-30.567.119-41.233.604c-10.646.488-17.913 2.173-24.271 4.646c-6.578 2.554-12.157 5.971-17.715 11.531c-5.563 5.559-8.98 11.138-11.542 17.713c-2.48 6.36-4.167 13.63-4.646 24.271c-.477 10.667-.602 14.077-.602 41.236s.12 30.557.604 41.223c.49 10.646 2.175 17.913 4.646 24.271c2.556 6.578 5.973 12.157 11.533 17.715c5.557 5.563 11.136 8.988 17.709 11.542c6.363 2.473 13.631 4.158 24.275 4.646c10.667.485 14.073.604 41.23.604c27.161 0 30.559-.119 41.225-.604c10.646-.488 17.921-2.173 24.284-4.646c6.575-2.554 12.146-5.979 17.702-11.542c5.563-5.558 8.979-11.137 11.542-17.712c2.458-6.361 4.146-13.63 4.646-24.272c.479-10.666.604-14.066.604-41.225s-.125-30.567-.604-41.234c-.5-10.646-2.188-17.912-4.646-24.27c-2.563-6.578-5.979-12.157-11.542-17.716c-5.562-5.562-11.125-8.979-17.708-11.53c-6.375-2.474-13.646-4.16-24.292-4.647c-10.667-.485-14.063-.604-41.23-.604h.031Zm-8.971 18.021c2.663-.004 5.634 0 8.971 0c26.701 0 29.865.096 40.409.575c9.75.446 15.042 2.075 18.567 3.444c4.667 1.812 7.994 3.979 11.492 7.48c3.5 3.5 5.666 6.833 7.483 11.5c1.369 3.52 3 8.812 3.444 18.562c.479 10.542.583 13.708.583 40.396c0 26.688-.104 29.855-.583 40.396c-.446 9.75-2.075 15.042-3.444 18.563c-1.812 4.667-3.983 7.99-7.483 11.488c-3.5 3.5-6.823 5.666-11.492 7.479c-3.521 1.375-8.817 3-18.567 3.446c-10.542.479-13.708.583-40.409.583c-26.702 0-29.867-.104-40.408-.583c-9.75-.45-15.042-2.079-18.57-3.448c-4.666-1.813-8-3.979-11.5-7.479s-5.666-6.825-7.483-11.494c-1.369-3.521-3-8.813-3.444-18.563c-.479-10.542-.575-13.708-.575-40.413c0-26.704.096-29.854.575-40.396c.446-9.75 2.075-15.042 3.444-18.567c1.813-4.667 3.983-8 7.484-11.5c3.5-3.5 6.833-5.667 11.5-7.483c3.525-1.375 8.819-3 18.569-3.448c9.225-.417 12.8-.542 31.437-.563v.025Zm62.351 16.604c-6.625 0-12 5.37-12 11.996c0 6.625 5.375 12 12 12s12-5.375 12-12s-5.375-12-12-12v.004Zm-53.38 14.021c-28.36 0-51.354 22.994-51.354 51.355c0 28.361 22.994 51.344 51.354 51.344c28.361 0 51.347-22.983 51.347-51.344c0-28.36-22.988-51.355-51.349-51.355h.002Zm0 18.021c18.409 0 33.334 14.923 33.334 33.334c0 18.409-14.925 33.334-33.334 33.334c-18.41 0-33.333-14.925-33.333-33.334c0-18.411 14.923-33.334 33.333-33.334Z"></path><defs><radialGradient id="IconifyId-1930aa7e158-d136c0-8" cx="0" cy="0" r="1" gradientTransform="matrix(0 -253.715 235.975 0 68 275.717)" gradientUnits="userSpaceOnUse"><stop stop-color="#FD5"></stop><stop offset=".1" stop-color="#FD5"></stop><stop offset=".5" stop-color="#FF543E"></stop><stop offset="1" stop-color="#C837AB"></stop></radialGradient><radialGradient id="IconifyId-1930aa7e158-d136c0-9" cx="0" cy="0" r="1" gradientTransform="matrix(22.25952 111.2061 -458.39518 91.75449 -42.881 18.441)" gradientUnits="userSpaceOnUse"><stop stop-color="#3771C8"></stop><stop offset=".128" stop-color="#3771C8"></stop><stop offset="1" stop-color="#60F" stop-opacity="0"></stop></radialGradient></defs></g></svg>`,
  EMAIL = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24" style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);"><g fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="M0 0h24v24H0z"></path><path fill="#0078d7" d="M22 7.535V17a3 3 0 0 1-2.824 2.995L19 20H5a3 3 0 0 1-2.995-2.824L2 17V7.535l9.445 6.297l.116.066a1 1 0 0 0 .878 0l.116-.066L22 7.535z"></path><path fill="#0078d7" d="M19 4c1.08 0 2.027.57 2.555 1.427L12 11.797l-9.555-6.37a2.999 2.999 0 0 1 2.354-1.42L5 4h14z"></path></g></svg>`,
}
